<app-loading
  [loading] = loading
></app-loading>

<ng-container *ngIf="!isModal">
  <app-header></app-header>
  <app-sidebar></app-sidebar>
  <div class="content-wrapper">
    <section class="content">
      <app-breadcrumb
        Titulo="Novo documento"
        Pagina="Novo"
        [TemPaginaPai] = true
        LinkPaginaPai="/juridico/documento-processo"
        PaginaPai="Documento"
      ></app-breadcrumb>
      <div class="row">
        <div class="col-md-12">
          <ng-container [ngTemplateOutlet]="formTemplate"></ng-container>
        </div>
      </div>
    </section>
  </div>
</ng-container>

<div class="modal-overlay" *ngIf="isModal && modalNovoDocumento" (click)="!loading && fecharModal()">
  <div class="box-atendimento-novo" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5 class="fw-bold">
          <i class="fa fa-file-text"></i> Novo Documento
        </h5>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn-close" (click)="fecharModal()" aria-label="Close" [disabled]="loading"></button>
      </div>
    </div>
    <hr>
    <div class="modal-body p-0">
      <ng-container [ngTemplateOutlet]="formTemplate"></ng-container>
    </div>
  </div>
</div>

<ng-template #formTemplate>
  <div [ngClass]="{'card card-blue': !isModal}">
    <form [formGroup]="formCadastrar" id="formCadastrar">
      <div [ngClass]="{'card-body': !isModal}">
        <div class="row">
          <div class="col-md-12 mb-3">
            <div class="form-group">
              <label for="descricao">Descrição:</label>
              <div class="custom-select-container">
                <i class="fa fa-font icon"></i>
                <input type="text" id="descricao" formControlName="descricao" class="form-control">
              </div>
            </div>
          </div>
          <div class="col-md-12 mb-3">
            <div class="form-group">
              <label for="tipo">Tipo Documento:</label>
              <div class="custom-select-container">
                <i class="fa fa-tags icon"></i>
                <ng-select [items]="tiposDocumento"
                           bindLabel="descricao"
                           bindValue="id"
                           formControlName="tipo"
                           [clearable]="false"
                           placeholder="Selecione"
                           id="tipo">
                </ng-select>
              </div>
            </div>
          </div>
          <div class="col-md-12 mb-3">
            <div class="form-group">
              <label for="processo">Processo</label>
              <div class="custom-select-container">
                <i class="fa fa-balance-scale icon"></i>
                <ng-select
                  id= "processo"
                  [items]="itensProcesso | async"
                  bindLabel="titulo"
                  bindValue="id"
                  formControlName="processo">
                </ng-select>
              </div>
            </div>
          </div>
          <div class="col-md-12 mb-3">
            <div class="form-group">
              <label for="pasta" class="d-flex align-items-center justify-content-between">
                <span>Pasta</span>
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="abrirModalNovaPasta()" title="Nova pasta">
                  <i class="fa fa-plus"></i>
                </button>
              </label>
              <div class="custom-select-container">
                <i class="fa fa-folder icon"></i>
                <ng-select
                  id="pasta"
                  [items]="itensPasta | async"
                  bindLabel="descricao"
                  bindValue="id"
                  formControlName="pasta">
                </ng-select>
              </div>
            </div>
          </div>

          <app-nova-pasta-documento
            [origemId]="formCadastrar.value.processo || 0"
            (pastaCriada)="listarPastas()"
          ></app-nova-pasta-documento>
          <div class="col-md-12 mb-3">
            <div class="form-group">
              <label for="arquivo">Arquivo:</label>
              <div class="custom-select-container">
                <i class="fa fa-paperclip icon"></i>
                <input type="file" (change)="getArquivo($event)"  id="arquivo" formControlName="arquivo" class="form-control">
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12 d-flex justify-content-end gap-2 mt-4">
            <button type="button" class="btn btn-light" (click)="voltar()" [disabled]="loading">
              {{ isModal ? 'Cancelar' : 'Voltar' }}
            </button>
            <button type="button" class="btn btn-primary px-4 d-flex align-items-center gap-2" (click)="salvar()" [disabled]="loading">
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              {{ loading ? 'Salvando...' : 'Salvar' }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>

